import { render, staticRenderFns } from "./ActiveProductPage.vue?vue&type=template&id=6b86a1e4&scoped=true&"
import script from "./ActiveProductPage.vue?vue&type=script&lang=js&"
export * from "./ActiveProductPage.vue?vue&type=script&lang=js&"
import style0 from "./ActiveProductPage.vue?vue&type=style&index=0&id=6b86a1e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b86a1e4",
  null
  
)

export default component.exports